module.exports = __webpack_public_path__ + "assets/img/bg_end.1e0bdfe7.svg";